<template>
    <section class="black-bg">
        <b-container class="position-relative pi-container-width">
            <b-row class="width-70-flow-chart py-2 z-index-class">
                <b-col>
                    <div class="d-flex align-items-center justify-content-center">
                        <Skeleton height="2.5rem" width="90px" v-if="loading" />
                        <WhiteBox v-else boxtext="With R C" tooltipContent="With Rate Contract" />
                    </div>
                </b-col>
            </b-row>
            <b-row class="width-100-flow-chart py-2 z-index-class">
                <b-col>
                    <div class="d-flex align-items-center">
                        <Skeleton shape="circle" size="3.3rem" v-if="loading" />
                        <div class="icon-box-purple" v-else>
                            <p style="color: black !important;">Items</p>
                            <i class="pi pi-download"></i>
                        </div>
                        <div class="display--white-dot-contents pi-box-margin">
                            <Skeleton height="2.5rem" width="90px" v-if="loading" />
                            <WhiteBox v-else boxtext="PI" tooltipContent="Purchase Indent" />
                        </div>
                    </div>
                </b-col>
                <b-col>
                    <div class="d-flex align-items-center pocolumn">
                        <div class="display--white-dot-contents">
                            <Skeleton height="2.5rem" width="90px" v-if="loading" />
                            <WhiteBox boxtext="PO" tooltipContent="Purchase Order"
                                :Badge="data_insert.poarraylenght !== '' ? true : false"
                                :count="data_insert.poarraylenght" v-else />
                        </div>
                        <div class="display--white-dot-contents center-box-margin">
                            <Skeleton height="2.5rem" width="90px" v-if="loading" />
                            <WhiteBox boxtext="Vendor" tooltipContent="Vendor" v-else />
                        </div>
                        <div class="display--white-dot-contents">
                            <Skeleton height="2.5rem" width="90px" v-if="loading" />
                            <WhiteBox boxtext="GRN" tooltipContent="GRN"
                                :Badge="data_insert.grnarraylenght !== '' ? true : false"
                                :count="data_insert.grnarraylenght" v-else />
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-row class="width-70-flow-chart pt-2  z-index-class">
                <b-col>
                    <div class="d-flex align-items-center justify-content-center">
                        <div class="display--white-dot-contents">
                            <Skeleton height="2.5rem" width="90px" v-if="loading" />
                            <WhiteBox boxtext="Without R C" tooltipContent="Without Rate Contract" v-else />
                        </div>
                        <div class="display--white-dot-contents center-box-margin">
                            <Skeleton height="2.5rem" width="90px" v-if="loading" />
                            <WhiteBox boxtext="Quote" tooltipContent="Quote"
                                :Badge="data_insert.Qarraylenght !== '' ? true : false"
                                :count="data_insert.Qarraylenght" v-else />
                        </div>
                        <div class="display--white-dot-contents">
                            <Skeleton height="2.5rem" width="90px" v-if="loading" />
                            <WhiteBox boxtext="Vendor" tooltipContent="Vendor" v-else />
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-row class="py-2">
                <b-col class="d-flex position-class">
                    <div class="flow-outline1">

                    </div>
                    <div class="flow-outline2">

                    </div>
                    <div class="flow-outline3">

                    </div>
                </b-col>
            </b-row>
        </b-container>
    </section>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, reactive } from "vue";
import WhiteBox from './PIChartWhiteBox.vue'
export default defineComponent({
    components: {
        WhiteBox
    },
    props: {
        value: {

        },
        loading: {
            type: Boolean,
            default: false
        },
    },
    setup(props, { emit }) {
        const tooltipContent = ref("Tooltip content");
        let ObjVal = ref({
            arraylenght: '0',
        });


        onMounted(() => {
            Object.assign(data_insert, props.value);
            update();

        })
        function update() {
            emit("update:modelValue", data_insert);
        }
        let data_insert = reactive({
            poarraylenght: '',
            Qarraylenght: '',
            grnarraylenght: '',

        });
        return {
            tooltipContent,
            ObjVal,
            data_insert
            // ObjVal1,
        };
    },
});
</script>

<style>
.black-bg {
    /* background-color: black;
    height: 40vh;
    padding: 2% 0px; */
    background-image: radial-gradient(#999999 10%, #444444 10%);
    background-size: 20px 20px;
    height: 25vh;
    /* Adjust the size of the dots */
}

.flow-outline1 {
    border-bottom: 1px solid #e1e1e1;
    border-right: 0px;
    width: 16%;
    height: 54px;
}

.flow-outline2 {
    border: 1px solid #e1e1e1;
    width: 40%;
    height: 106px;
}

.flow-outline3 {
    border-bottom: 1px solid #e1e1e1;
    width: 25%;
    height: 54px;
}



.icon-box-orange {
    background-color: orange;
    border-radius: 8px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    width: 60px;
    height: 30px;
}

.icon-box-green {
    background-color: green;
    border-radius: 8px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    width: 60px;
    height: 30px;
}

.icon-box-purple {
    background-color: purple;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.width-70-flow-chart {
    width: 62%;
    margin: 0 11% !important;
    position: relative;
}

.width-100-flow-chart {
    width: 100%;
    margin: 0 auto !important;
    position: relative;
}

.width-100-flow-chart .pocolumn {
    padding-left: 25% !important;
}

.z-index-class {
    z-index: 10;
}

.black-bg p {
    font-size: 10px;
    color: #000000;
}

.position-class {
    position: absolute;
    top: 13.5%;
    left: 5.1%;
}

.orange-card {
    margin-left: 4%;
    margin-right: 4%;
}

.orangecard-1 {
    margin-right: 2%;
}

.center-box-margin {
    margin-left: 30px;
    margin-right: 30px;
}

.pi-box-margin {
    margin-left: 30px;
}

.display--white-dot-contents {
    display: flex;
    align-items: center;
}

.pi-container-width {
    width: 88% !important;
    max-width: 88% !important;
    margin: auto;
}

@media only screen and (max-width: 1024px) and (min-width: 992px) {
    .flow-outline1 {
        height: 51px;
    }

    .flow-outline2 {
        height: 100px;
    }

    .flow-outline3 {
        height: 51px;
    }
}

@media only screen and (max-width: 992px) and (min-width: 768px) {

    .flow-outline1 {
        height: 48px;
    }

    .flow-outline3 {
        height: 48px;
    }
}

/* 700px */

/* .position-class {
    position: absolute;
    top: 13.5%;
    left: 1.1%;
}
.flow-outline1 {
    width: 21.2%;
}
.flow-outline2 {
    width: 37%;
} */

/* 700px */
</style>
